import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface SmsReminderRecord {
  appointmentId: number;
  gid: number;
  PID: number;
  patientID: string;
  mobile: string;
  smsSentTime: Date;
  answerMessage: string;
  answerStatus: number;
  originalAptTime: Date;
  examType: number;
  First: string;
  Last: string;
  clinicName: string;
  totalUserChanges: number;
  totalPatientChanges: number;
  wasDeleted: boolean;
  dateChanged: boolean;
  arrivalConfirm: boolean | null;
  arrivalConfirmedViaSMS: boolean;
  arrivalConfirmedViaSMSDate: Date | null;
  arrivalConfirmedViaUser: boolean;
  arrivalConfirmedViaUserDate: Date | null;
  confirmationCode: string | null;
  confirmationLink: string | null;
  messageBody: string | null;
}

export interface SmsRemindersResponse {
  date: string;
  stats: {
    totalSent: number;
    totalSmsSent?: number;
    uniqueAppointments?: number;
    duplicateReminders?: number;
    successful: number;
    failed: number;
    deleted: number;
    dateChanged: number;
    noChanges: number;
    confirmedViaSMS: number;
    declinedViaSMS: number;
    arrivedViaUser: number;
    noResponse: number;
    cronSent?: number;
    manualSent?: number;
  };
  records: SmsReminderRecord[];
}

export interface SmsPreviewResponse {
  messageBody: string;
  confirmationLink: string | null;
  confirmationCode: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class SmsRemindersTrackingService {
  constructor(private http: HttpClient) {}

  getSmsReminders(date: string): Observable<SmsRemindersResponse> {
    return this.http.get<SmsRemindersResponse>(`/api/sms-reminders/${date}`);
  }

  getSmsPreview(appointmentId: number): Observable<SmsPreviewResponse> {
    return this.http.get<SmsPreviewResponse>(`/api/sms-reminders/${appointmentId}/preview`);
  }
}
